import Screen from '@shared/utils/screen';
import styled from 'styled-components';

const ChannelListPosterContainer = styled.div<React.CSSProperties>`
  height: ${300 * Screen.widthRatio}px;
  width: ${200 * Screen.widthRatio}px;
`;

export default ChannelListPosterContainer;
